import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import api from "../lib/api";
import { Logo } from "../components/common";
import { usePageMeta } from "../lib/seo";

export default function Privacy() {
  const [notice, setNotice] = useState(null);
  usePageMeta("Privacy Notice (POPIA) | Servantage", "/privacy");
  useEffect(() => { api.get("/public/privacy").then((r) => setNotice(r.data)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-2xl px-6 py-10">
        <Logo />
        <Link to="/" className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-indigo-600 hover:underline" data-testid="privacy-back">
          <ArrowLeft className="h-4 w-4" /> Back
        </Link>
        <h1 className="mt-6 font-head text-3xl font-bold text-slate-900">{notice?.title || "Privacy Notice"}</h1>
        <div className="mt-6 space-y-4">
          {(notice?.body || []).map((p, i) => (
            <p key={i} className="flex gap-3 text-slate-600">
              <ShieldCheck className="mt-0.5 h-5 w-5 flex-shrink-0 text-indigo-500" />
              <span>{p}</span>
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}
